import qs from 'query-string'

import type { Golf, GolfAutocomplete, SearchGolfsDTO } from '../types/golfs'
import type { GolfLite, Range } from '../types/shared'

export const useGolfsService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/api/golfs`

  return {
    getGolf(id: number | string) {
      return fetchJson<FetchResult<Golf>>(
        'GET', `${BASE_URL}/${id}`,
      )
    },
    getGolfsAutocomplete(params: { nom?: string, begolf?: boolean }) {
      return fetchJson<FetchResult<GolfAutocomplete[]>>(
        'GET', `${BASE_URL}/autocomplete?${qs.stringify(params)}`,
      )
    },
    postGolfsSearch(payload: SearchGolfsDTO) {
      return fetchJson<{ data: GolfLite[], ranges: Range }, typeof payload>(
        'POST', `${BASE_URL}/search`, payload,
      )
    },
  }
}
